import React from "react";
import { useNavigate } from "react-router-dom";

const Logo = ({ image }) => {
  // If we use link here we are getting a warning in console thats we are using custom function to navigate to home page

  const navigate = useNavigate();
  const handleRoute = () => {
    navigate("/");
  };
  return (
    <>
      <div className="logo" onClick={handleRoute}>
        <img
          src={image}
          alt="logo images"
          className="header-logo"
          style={{
            cursor: "pointer",
          }}
        />
      </div>
    </>
  );
};

export default Logo;
